import { ContentItem, IImageContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import { MediaContentTypes } from './types'

export const extractContentGroups = (items: ContentItem[]) => {
  const itemsByGroup = {
    [MediaContentTypes.Builder]: [] as ContentItem[],
    [MediaContentTypes.ThreeDView]: [] as ContentItem[],
    [MediaContentTypes.Video]: [] as ContentItem[],
    [MediaContentTypes.All]: [] as ContentItem[],
  }

  for (const item of items) {
    if (item.contentType === 'video') {
      itemsByGroup[MediaContentTypes.Video].push(item)
    } else if (item.contentType === 'oxomi3DImage') {
      itemsByGroup[MediaContentTypes.ThreeDView].push(item)
    } else {
      itemsByGroup[MediaContentTypes.Builder].push(item)
    }

    itemsByGroup[MediaContentTypes.All].push(item)
  }

  return {
    itemsByGroup,
    totals: {
      builderItemsTotal: itemsByGroup[MediaContentTypes.Builder].length,
      videoItemsTotal: itemsByGroup[MediaContentTypes.Video].length,
      threeDViewItemsTotal: itemsByGroup[MediaContentTypes.ThreeDView].length,
    },
  }
}

// All items without typeName field ( article images )
export const PRODUCT_BUILDER_CATEGORY = 'Produktbilder'

export const getOxomiImagesByGroup = (items: IImageContentItem[]) => {
  const itemsByGroup: Record<string, IImageContentItem[]> = {}

  for (const item of items) {
    const key = item.typeName || PRODUCT_BUILDER_CATEGORY
    if (!itemsByGroup[key]) {
      itemsByGroup[key] = []
    }
    itemsByGroup[key].push(item)
  }

  return itemsByGroup
}

export const getBuilderFilterOptions = (items: IImageContentItem[]) => {
  const totals: Record<string, number> = {}

  for (const item of items) {
    const type = item.typeName || PRODUCT_BUILDER_CATEGORY
    totals[type] = (totals[type] || 0) + 1
  }

  return Object.entries(totals).map(([type, count]) => ({
    label: type,
    value: type,
    total: count >= 1 ? count : undefined,
    disabled: count === 0,
  }))
}
